import React from "react";
import MyUser from "@/layouts/components/User";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import _ from "lodash";
import "./index.less";

import LogoIcon from "@/assets/images/factory-logo.png";

const Header: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: 78 }} className="header_root">
      <div className="logo-box" onClick={() => navigate("/work-bench")}>
        <div>
          <img src={LogoIcon} width={200} alt="" />
        </div>
      </div>
      <div className="tool-box">
        <div className="head-user-box">
          <MyUser />
        </div>
      </div>
    </div>
  );
};

export default observer(Header);
